import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import Navigation from "./navigation";

let vh = window.innerHeight * 0.01;

const useStyles = makeStyles({
    scrollable: {
        ['@media (max-width: 640px)']: {
            overflowY: 'scroll',
            minHeight: 100*vh-68,
        },
        ['@media (min-width: 640px)']: {
            overflowY: 'scroll',
            minHeight: 720-68,
        },
    },
    main: {
        position: 'relative',
        background: 'linear-gradient(180.02deg, #FF8A00 0.02%, #58AF56 121.49%, #58AF56 180.83%)',
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: 'inherit',
        height: '100%',
        width: '100%',
        padding: 0,
        margin: 0,
        top: 0,
        left: 0,
        boxSizing: 'inherit',
        borderRadius: 'inherit',
    },
    logo: {
        flex: '0 1 auto',
        textAlign: 'center',
        marginTop: '7%',
        // marginLeft: '7%',
        // marginRight: '7%',
        marginBottom: '20%',
        height: '15%',
        width: '73%',
        maxHeight: '130px',
        maxWidth: '340px',
    },
    text1: {
        flex: '0 1 auto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '22px',
        lineHeight: '30px',
        textAlign: 'center',
        margin: '30px',
        color: '#000000',
    },
    text2: {
        flex: '0 1 auto',
        fontStyle: 'normal',
        fontWeight: 'bold',
        fontSize: '22px',
        lineHeight: '30px',
        textAlign: 'center',
        margin: '30px',
        color: '#000000',
    },
    divider: {
        flex: '0 1 auto',
        align: 'center',
        background: '#000000',
        border: "3px solid #000000",
        boxSizing: "border-box",
        borderRadius: '3px',
        marginLeft: '30%',
        marginRight: '30%',
        width: '40%',
    },
});

export default function Welcome() {
    const classes = useStyles();
    return (
        <main className={classes.main}>
            <div className={classes.scrollable}>
                <img src={'logo.svg'} className={classes.logo}/>
                <p className={classes.text1}>Co wiesz o zmianach klimatu?</p>
                <div className={classes.divider}/>
                <p className={classes.text2}>Sprawdź swoją wiedzę i poznaj wiarygodne źródła informacji o klimacie</p>
                <div style={{flex: '1 1 auto'}}/>
            </div>
            <Navigation buttonPath={'/quiz-klimatyczny/instructions'} buttonText={'pierwszy krok'} isGreen={true}/>
        </main>
    );
}